<app-content-header [contentHeader]="contentHeader"></app-content-header>


<div class="card">
    <div class="card-body">
        <h4 class="card-title">
            <a href="#/admin/company/{{delivery.companyId}}">
                {{delivery.companyName}}
            </a>
        </h4>
    </div>
    <div class="card-body row d-flex">
        <div class="col-md-3" *ngIf="delivery.companyPersonName && delivery.companyPersonLastName">
            <strong>Yetkili Kişi</strong>
            <p>{{ delivery.companyPersonName + ' ' + delivery.companyPersonLastName }}</p>
        </div>

        <!-- Teklif No -->
        <div class="col-md-3" *ngIf="delivery.no">
            <strong>Teklif No</strong>
            <p>{{ delivery.no }}</p>
        </div>

        <!-- Teslim Alma Tarihi -->
        <div class="col-md-3" *ngIf="delivery.deliveryDate">
            <strong>Teslim Tarihi</strong>
            <p>{{ delivery.deliveryDate | date:'dd.MM.yyyy' }}</p>
        </div>

        <!-- Teslim Alma Şekli -->
        <div class="col-md-3" *ngIf="delivery.deliveryMethodName">
            <strong>Teslim Şekli</strong>
            <p>{{ delivery.deliveryMethodName }}</p>
        </div>

        <!-- Getiren Kişi -->
        <div class="col-md-3" *ngIf="delivery.deliveryPerson">
            <strong>Getiren Kişi</strong>
            <p>{{ delivery.deliveryPerson }}</p>
        </div>

        <!-- Bizim Personel -->
        <div class="col-md-3" *ngIf="delivery.personName && delivery.personLastName">
            <strong>Bizim Personel</strong>
            <p>{{ delivery.personName + ' ' + delivery.personLastName }}</p>
        </div>

        <!-- Açıklama -->
        <div class="col-6">
            <div>
                <strong>Açıklama</strong>
                <p class="mb-0">{{ delivery.description }}</p>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-icon btn-warning" rippleEffect
            (click)="showDeliveryUpdateDilaog(delivery.id)">
            <span [data-feather]="'edit'"></span>
        </button>
    </div>
</div>

<div class="card">
    <div class="col-12 d-flex justify-content-between align-items-center p-25">
        <div class="col-xl-6 col-md-6 col-sm-12">
            <label>Cihaz Seç</label>
            <div class="form-group">
                <ng-select [items]="devices" bindLabel="brandName" bindValue="id" (change)="onDeviceSelect($event)"
                    [formControl]="deviceControl">
                    <ng-template ng-header-tmp>
                        <button
                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                            (click)="showCreateDeviceDialog(); select.blur(); select.close()">
                            <i data-feather="plus"></i>
                            <span class="align-middle ml-25">Yeni Cihaz Ekle</span>
                        </button>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <h6 class="mb-1">{{item.deviceName}}</h6>
                        <p class="card-subtitle mb-2 text-muted">
                            {{ item.brandName }} / {{item.modelName}} - {{item.seriNo}} - {{item.typeName}}
                        </p>
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <label class="d-flex align-items-center">
                <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="50">50</option>
                </select>
            </label>
        </div>
    </div>

    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [rowHeight]="100" [scrollbarH]="true">

        <ngx-datatable-column name="Cihaz Adı" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">

                <p class="font-weight-bold">
                    {{row.deviceName}}
                    <br>
                    <span class="text-muted font-small-2">{{ row.seriNo }}</span>
                </p>

            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Sert. Bas. Firma" prop="companyName" [width]="250"></ngx-datatable-column>
        <ngx-datatable-column name="Tür" prop="typeName" [width]="100"></ngx-datatable-column>

        <ngx-datatable-column name="Durum" prop="deviceAcceptanceStatesName" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge" [ngClass]="{
                              'badge-info': row.deviceAcceptanceStatesName === 'Bekliyor',
                              'badge-success': row.deviceAcceptanceStatesName === 'Tamamlandı',
                              'badge-danger': row.deviceAcceptanceStatesName === 'İptal Edildi',
                              'badge-warning': row.deviceAcceptanceStatesName !== 'Bekliyor' && row.deviceAcceptanceStatesName !== 'Tamamlandı' && row.deviceAcceptanceStatesName !== 'İptal Edildi'
                          }">
                    {{ row.deviceAcceptanceStatesName ??'' }}
                </span>
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Teslim Eden Pers." prop="personName" [width]="120"></ngx-datatable-column>
        <ngx-datatable-column name="Teslim Alan Kişi" prop="deliveryPerson" [width]="120"></ngx-datatable-column>


        <ngx-datatable-column name="Gönderim Şekli" prop="deliveryMethodName" [width]="150"></ngx-datatable-column>

        <ngx-datatable-column name="#">
            <ng-template ngx-datatable-cell-template let-row="row">

                <div ngbDropdown container="body">
                    <button ngbDropdownToggle type="button"
                        class="btn btn-flat-primary dropdown-toggle-split hide-arrow" rippleEffect>
                        <span [data-feather]="'more-vertical'" class="'dropdown-icon'"></span>
                    </button>
                    <div ngbDropdownMenu>
                        <a *ngIf="rows.length > 1" href="javascript:void(0)" ngbDropdownItem
                            class="d-flex align-items-center" appDelete [id]="row.id" controller="DeliveryDevices"
                            (callback)="this.getDeliveryByIdDevices(this.pageBasic - 1, this.selectedSize, this.delivery.id)"><i
                                data-feather="trash-2" class="mr-50"></i> Sil</a>
                        <a href="javascript:void(0)" ngbDropdownItem class="d-flex align-items-center"
                            (click)="deliveryCompanyId(row)"><i data-feather="edit" class="mr-50"></i> Srtf. Cih.
                            Güncelle</a>
                        <a href="javascript:void(0)" ngbDropdownItem class="d-flex align-items-center"
                            (click)="showDeliveryDeviceUpdateDilaog(row.id)"><i data-feather="file-text"
                                class="mr-50"></i>Teslim Et</a>

                        <a href="javascript:void(0)" ngbDropdownItem class="d-flex align-items-center"
                            *ngIf="row.isCalibration" (click)="showCreateCalibrationDialog(row.id)"><i
                                data-feather="archive" class="mr-50"></i>Kalibrasyon Yap</a>

                        <a href="javascript:void(0)" ngbDropdownItem class="d-flex align-items-center"
                            *ngIf="row.isCalibration" (click)="showCreateCertificate(row.calibrationId)"><i data-feather="file"
                                class="mr-50"></i>Sertifika Oluştur</a>
                    </div>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>